import PropTypes from 'prop-types';
import React from 'react';

import IfmsButton, { IfmsButtonProps } from './IfmsButton';

const DeepBlueButtonTabs = React.forwardRef<HTMLButtonElement, IfmsButtonProps>(({children, ...other}, ref) => {
  return (
    <IfmsButton ref={ref} {...other} baseClass="ifms-deepblue-tab-button ifms-button-tabs">
      {children}
    </IfmsButton>
  );
});

DeepBlueButtonTabs.defaultProps = {
};

DeepBlueButtonTabs.propTypes = {
  size: PropTypes.oneOf(['regular', 'small', 'large', 'extrasmall']),
};

export default React.memo(DeepBlueButtonTabs);